export const STATUS = {
    DECLINED: 'Declined',
    CONFIRMED: 'Confirmed',
    CANCELLED: 'Cancelled',
    QUOTE: 'Quote',
    APPROVAL_IS_EXPIRED: 'Approval is expired',
};

export default function TripItemRecommendationService() {
    Object.assign(this, {
        isDeclined,
        isConfirmed,
        isCancelled,
        isQuote,
        isApprovalExpired,
    });

    function isDeclined(recommendation) {
        return recommendation
            && recommendation.Status === STATUS.DECLINED;
    }

    function isConfirmed(recommendation) {
        return recommendation
            && recommendation.Status === STATUS.CONFIRMED;
    }

    function isCancelled(recommendation) {
        return recommendation
            && recommendation.Status === STATUS.CANCELLED;
    }

    function isQuote(recommendation) {
        return recommendation
            && recommendation.Status === STATUS.QUOTE;
    }

    function isApprovalExpired(recommendation) {
        return recommendation
            && recommendation.Status === STATUS.APPROVAL_IS_EXPIRED;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-recommendation-service.js